// frontend/src/components/vacancy/VacancyFilters.tsx

import React, { useState } from 'react'
import { Input } from '@/components/common/UI/Input'
import { Select } from '@/components/common/UI/Select'
import { Button } from '@/components/common/UI/Button'
import { Card } from '@/components/common/UI/Card'
import { CityAutocomplete } from '@/components/common/CityAutocomplete'

interface VacancyFiltersProps {
  onFilterChange: (filters: any) => void
  initialFilters?: any
}

export const VacancyFilters: React.FC<VacancyFiltersProps> = ({
  onFilterChange,
  initialFilters = {}
}) => {
  const [filters, setFilters] = useState({
    city: initialFilters.city || '',
    experience_level: initialFilters.experience_level || '',
    salary_from: initialFilters.salary_from || '',
    salary_to: initialFilters.salary_to || '',
    employment_type: initialFilters.employment_type || '',
    remote_only: initialFilters.remote_only || false,
    work_schedule: initialFilters.work_schedule || ''
  })

  const experienceOptions = [
    { value: '', label: 'Любой опыт' },
    { value: 'no_experience', label: 'Без опыта' },
    { value: 'less_1_year', label: 'Менее 1 года' },
    { value: 'from_1_to_3', label: '1-3 года' },
    { value: 'from_3_to_6', label: '3-6 лет' },
    { value: 'more_6', label: 'Более 6 лет' }
  ]

  const employmentOptions = [
    { value: '', label: 'Любая занятость' },
    { value: 'full_time', label: 'Полная занятость' },
    { value: 'part_time', label: 'Частичная занятость' },
    { value: 'project', label: 'Проектная работа' },
    { value: 'internship', label: 'Стажировка' },
    { value: 'remote', label: 'Удаленная работа' }
  ]

  const scheduleOptions = [
    { value: '', label: 'Любой график' },
    { value: 'shift', label: 'Сменный график' },
    { value: 'flexible', label: 'Гибкий график' },
    { value: 'remote', label: 'Удалённая работа' },
    { value: 'hybrid', label: 'Гибридный график' }
  ]

  const handleChange = (key: string, value: any) => {
    const newFilters = { ...filters, [key]: value }
    setFilters(newFilters)
    onFilterChange(newFilters)
  }

  const handleReset = () => {
    const resetFilters = {
      city: '',
      experience_level: '',
      salary_from: '',
      salary_to: '',
      employment_type: '',
      remote_only: false,
      work_schedule: ''
    }
    setFilters(resetFilters)
    onFilterChange(resetFilters)
  }

  return (
    <Card className="p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Город */}
        <CityAutocomplete
          value={filters.city}
          onChange={(value) => handleChange('city', value)}
          placeholder="Все города"
        />

        {/* Опыт */}
        <Select
          label="Опыт работы"
          options={experienceOptions}
          value={filters.experience_level}
          onChange={(value: string) => handleChange('experience_level', value)}
        />

        {/* Тип занятости */}
        <Select
          label="Тип занятости"
          options={employmentOptions}
          value={filters.employment_type}
          onChange={(value: string) => handleChange('employment_type', value)}
        />

        <Select
          label="График работы"
          options={scheduleOptions}
          value={filters.work_schedule}
          onChange={(value: string) => handleChange('work_schedule', value)}
        />

        {/* Зарплата от */}
        <Input
          label="Зарплата от"
          type="number"
          placeholder="100000"
          value={filters.salary_from}
          onChange={(e) => handleChange('salary_from', e.target.value ? Number(e.target.value) : '')}
        />

        {/* Зарплата до */}
        <Input
          label="Зарплата до"
          type="number"
          placeholder="200000"
          value={filters.salary_to}
          onChange={(e) => handleChange('salary_to', e.target.value ? Number(e.target.value) : '')}
        />

        {/* Удаленная работа */}
        <div className="flex items-end">
          <label className="flex items-center gap-2 text-sm text-secondary-700">
            <input
              type="checkbox"
              checked={filters.remote_only}
              onChange={(e) => handleChange('remote_only', e.target.checked)}
              className="w-4 h-4 rounded border-secondary-300 text-primary-600 focus:ring-primary-500"
            />
            Только удаленная работа
          </label>
        </div>
      </div>

      <div className="flex justify-end mt-4">
        <Button variant="ghost" size="sm" onClick={handleReset}>
          Сбросить фильтры
        </Button>
      </div>
    </Card>
  )
}
